/* eslint-disable require-await */
import React, { useEffect, useState } from 'react';
import styles from './Uninstalled.css';

const TestError: React.FC = () => {
  const [throwOnRender, setThrowOnRender] = useState(false);
  const [throwOnPromise, setThrowOnPromise] = useState(false);

  // Unhndled delayed promise rejection
  useEffect(() => {
    const asyncThrowError = async () => {
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          // reject(new Error('Invalid data'));
          reject();
        }, 500);
      });

      await timeoutPromise;
    };

    if (throwOnPromise) {
      asyncThrowError();
    }
  }, [throwOnPromise]);

  //Umhandled error on render
  if (throwOnRender) {
    throw new Error('This is a render test error');
  }

  return (
    <div className={styles.wrap}>
      <h1>Error Testing Page</h1>
      <p>
        <input
          type="button"
          value="Throw Sync Error on Handler"
          onClick={() => {
            throw new Error('This is a handler test error');
          }}
        ></input>
        <input
          type="button"
          value="Throw Async Error on Handler"
          onClick={async () => {
            throw new Error('This is a handler test error');
          }}
        ></input>
        <input
          type="button"
          value="Throw Error on Render"
          onClick={() => {
            setThrowOnRender(true);
          }}
        ></input>
        <input
          type="button"
          value="Throw Error on Promise"
          onClick={() => {
            setThrowOnPromise(true);
          }}
        ></input>
      </p>
    </div>
  );
};

export default TestError;
